import React, {useSyncExternalStore} from 'react';
import { navigation } from '../js/alpine/stores/navigation';
import ExtendedFooter from "../src/stories/components/ExtendedFooter/ExtendedFooter";
import ExtendedHeader from "../src/stories/components/Header/ExtendedHeader";
import ExtendedMegamenu from "../src/stories/components/Megamenu/ExtendedMegamenu";
import ExtendedPromoBar from "../src/stories/components/PromotionBar/ExtendedPromotionBar";
import useMobileBreakpoint from "../src/hooks/useMobileBreakpoint";
import { inflateShared } from "../js/globals";

export function PromobarComponent({ ...props })
{
    // Hydrate shared props to ensure globals and other shared data is available
    const hydratedSettings = inflateShared(props.settings);
    
    return (
        <>
            <ExtendedPromoBar settings={hydratedSettings}/>
        </>
    )
}

export function HeaderComponent({ ...props })
{
    // Hydrate shared props to ensure globals and other shared data is available
    const hydratedSettings = inflateShared(props.settings);
    
    return (
        <>
            <ExtendedHeader settings={hydratedSettings} localization={hydratedSettings.localization} links={hydratedSettings.links} item_count={hydratedSettings.cart?.item_count} type={hydratedSettings.section?.layout} show_search_bar={hydratedSettings.section?.show_search_bar}/>
        </>
    )
}

export function FooterComponent({ ...props  })
{   
    // Hydrate shared props to ensure globals and other shared data is available
    const hydratedSettings = inflateShared(props.settings);
    
    return (
        <>
            <ExtendedFooter sublevel={ { locationsMeta: hydratedSettings.additional, contactsMeta:hydratedSettings.additional_extra }} globals={hydratedSettings.globals} settings={hydratedSettings.section} links={hydratedSettings.blocks} type={hydratedSettings.section?.layout} />
        </>
    )
}

export function MegamenuBlock({ ...props })
{
    // Hydrate shared props to ensure globals and other shared data is available
    const hydratedSettings = inflateShared(props.settings);
    
    const isMobile = useMobileBreakpoint('1024px');
    const id = 'header-' + hydratedSettings.section?.attach_to?.replace(' ', '-').toLowerCase()

    const menuItems = {
        id: id,
        label: hydratedSettings.section?.title,
        subMenuItems: hydratedSettings.links,
        blocks: hydratedSettings.blocks
    };

    const settings = {
        section_settings: hydratedSettings.section
    };

    function useMenuId() {
        // return 'header-shop'
        return useSyncExternalStore(navigation.store().subscribe, navigation.store().getMenuId);
        }
 
   
    return (
        <>
            {isMobile && <div className="bg-inherit">
                <ExtendedMegamenu settings={settings} translations={hydratedSettings.translations}  localization={hydratedSettings.localization}  menuItems={menuItems} id={id} state={useMenuId()}/>
            </div>}
            {!isMobile && <div className="bg-inherit" onMouseLeave={ function(){ navigation.store().setMenuId(null) }}>
                <ExtendedMegamenu settings={settings} translations={hydratedSettings.translations}  localization={hydratedSettings.localization} menuItems={menuItems} id={id} state={useMenuId()}/>
            </div>}
        </>
    )
}